import { Model } from '@vuex-orm/core';
import TechnologistOrderDocumentTypeConfig from '@/models/interfaces/TechnologistOrderDocumentType';
import TechnologistOrderDocumentTypeAPI from '@/api/TechnologistOrderDocumentTypeAPI';

export default class TechnologistOrderDocumentType extends Model {
    public static entity = 'technologistOrderDocumentType';

    public static fields() {
        return {
            id: this.attr(null),
            name: this.string(''),
            code: this.string(''),
        };
    }

    public static async getAll() {
        let documentTypes;
        try {
            documentTypes = await TechnologistOrderDocumentTypeAPI.getAll();
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: documentTypes.data,
        });
        return Promise.resolve();
    }

    public static async getById(id: string) {
        let documentType;
        try {
            documentType = await TechnologistOrderDocumentTypeAPI.getById(id);
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: documentType.data,
        });
        return Promise.resolve(documentType);
    }

    public static async updateExisting(id: string, info: TechnologistOrderDocumentTypeConfig) {
        let documentType;
        try {
            documentType = await TechnologistOrderDocumentTypeAPI.update(id, info);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(documentType);
    }

    public static async createNew(info: TechnologistOrderDocumentTypeConfig) {
        let documentType;
        try {
            documentType = await TechnologistOrderDocumentTypeAPI.create(info);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(documentType);
    }

    public static async deleteExisting(id: string) {
        try {
            await TechnologistOrderDocumentTypeAPI.delete(id);
        } catch (e) {
            return Promise.reject(e);
        }
        await TechnologistOrderDocumentType.delete(id);
        return Promise.resolve();
    }

    public id!: string;
    public name!: string;
    public code!: string;
}